var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LoadingService } from './../../../services/loading.service';
import { BountyResolver } from './../../../resolvers/bounty.resolver';
import { UserService } from './../../../services/user.service';
import { OnInit, OnDestroy } from '@angular/core';
import { BountyService } from '../../../services/bounty.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CLAIM_STATUS_COLORS } from '../../view-claim/view-claim.component';
import { SuiModalService } from 'ng2-semantic-ui';
import { ConfirmModal } from '../../confirm-modal/confirm-modal.component';
export var STATUS_COLORS = {
    new: 'green',
    'winner-chosen': 'blue',
    complete: 'green',
};
export var getBeatmapLink = function (bounty) {
    return "https://osu.ppy.sh/beatmapsets/" + bounty.beatmapset_id + "#" + (bounty.mode === 'ctb' ? 'fruits' : bounty.mode) + "/" + bounty.beatmap_id;
};
var ViewBountyComponent = /** @class */ (function () {
    function ViewBountyComponent(bountyService, route, userService, router, modalService, bountyResolver, loadingService) {
        this.bountyService = bountyService;
        this.route = route;
        this.userService = userService;
        this.router = router;
        this.modalService = modalService;
        this.bountyResolver = bountyResolver;
        this.loadingService = loadingService;
        this.showClaimBountyForm = false;
        this.statusColors = STATUS_COLORS;
        this.subscriptions = [];
    }
    ViewBountyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user = this.userService.getUser();
        this.isMod = this.user && this.user.isMod;
        this.subscriptions.push(this.route.data.subscribe(function (_a) {
            var data = _a.data;
            _this.mapDataToState(data);
        }));
    };
    ViewBountyComponent.prototype.mapDataToState = function (data) {
        var bounty = data.bounty, comments = data.comments;
        this.bounty = bounty;
        this.comments = comments;
        this.isOwner = this.user && bounty && bounty.user_id === this.user.id;
    };
    ViewBountyComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    Object.defineProperty(ViewBountyComponent.prototype, "title", {
        get: function () {
            return this.bountyService.getBountyTitle(this.bounty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "labelClass", {
        get: function () {
            return this.bountyService.getBountyLabelClass(this.bounty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "canDeleteBounty", {
        get: function () {
            return (this.isOwner && this.bounty.status === 'new') || this.isMod;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "canEditBounty", {
        get: function () {
            var hasActiveClaims = this.bounty.claims &&
                this.bounty.claims.some(function (claim) { return !['withdrawn', 'denied'].includes(claim.status); });
            return ((this.isOwner && this.bounty.status === 'new' && !hasActiveClaims) ||
                this.isMod);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "userCanClaim", {
        get: function () {
            var _this = this;
            return (this.user &&
                !this.isOwner &&
                !this.bounty.claims.some(function (claim) {
                    return (claim.user_id === _this.user.id && ['new'].includes(claim.status)) ||
                        claim.status === 'accepted';
                }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "canViewOwnClaim", {
        get: function () {
            return (!this.isOwner &&
                this.bounty &&
                this.bounty.userHasClaimed &&
                this.userClaim);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "canViewWinningClaim", {
        get: function () {
            return (this.isOwner &&
                this.bounty.claims.some(function (claim) { return claim.status === 'accepted'; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "winningClaim", {
        get: function () {
            return this.bounty.claims.find(function (claim) { return claim.status === 'accepted'; });
        },
        enumerable: true,
        configurable: true
    });
    ViewBountyComponent.prototype.deleteBounty = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.modalService
                    .open(new ConfirmModal('Delete Bounty', 'Are you sure you want to delete this bounty?'))
                    .onApprove(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.bountyService.deleteBounty(this.bounty.id)];
                            case 1:
                                _a.sent();
                                this.router.navigate(['/']);
                                return [2 /*return*/];
                        }
                    });
                }); })
                    .onDeny(function () { });
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(ViewBountyComponent.prototype, "beatmapHref", {
        get: function () {
            return getBeatmapLink(this.bounty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "userClaim", {
        get: function () {
            var _this = this;
            if (!this.user) {
                return;
            }
            return this.bounty.claims.find(function (claim) { return (claim.user_id = _this.user.id); });
        },
        enumerable: true,
        configurable: true
    });
    ViewBountyComponent.prototype.refetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadingService.loadWhileFetching(this.bountyResolver.resolve(this.route.snapshot))];
                    case 1:
                        data = _a.sent();
                        this.mapDataToState(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewBountyComponent.prototype.onBeatmapHrefClicked = function (event) {
        event.stopPropagation();
    };
    ViewBountyComponent.prototype.getStatusColor = function (claim) {
        return CLAIM_STATUS_COLORS[claim.status];
    };
    ViewBountyComponent.prototype.isClaimer = function (claim) {
        return this.user && this.user.id === claim.user_id;
    };
    ViewBountyComponent.prototype.goToClaim = function (claim) {
        if (!this.isOwner && !this.isClaimer(claim) && !this.isMod) {
            return;
        }
        this.router.navigate(['/claims/' + claim.id]);
    };
    ViewBountyComponent.prototype.editBounty = function () {
        this.router.navigate(['/bounties/' + this.bounty.id + '/edit']);
    };
    ViewBountyComponent.prototype.onClaimCreated = function (claimId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refetch()];
                    case 1:
                        _a.sent();
                        this.createdClaimId = claimId;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ViewBountyComponent.prototype, "hasNewClaims", {
        get: function () {
            return this.bounty.claims.some(function (claim) { return claim.status === 'new'; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBountyComponent.prototype, "amountValid", {
        get: function () {
            return (typeof this.amountToAdd === 'number') && this.amountToAdd > 1 && this.amountToAdd < 1000;
        },
        enumerable: true,
        configurable: true
    });
    ViewBountyComponent.prototype.parseReward = function (amount) {
        return parseFloat(amount.toFixed(2));
    };
    ViewBountyComponent.prototype.claimBountyAction = function () {
        this.showClaimBountyForm = true;
        setTimeout(function () {
            document.getElementById('claim-reward-section').scrollIntoView();
        }, 100);
    };
    return ViewBountyComponent;
}());
export { ViewBountyComponent };
